import { borderRadius } from "polished"
import { IconButton } from "../atoms/buttons"
import { HorizontalLayout } from "../components/layout"
import { ToggleSwitch } from "./ToggleSwitch"

export const PublishActionRow = ({ courseData, handleTogglePublish,viewStatus,handleCopyMode, handleEditMode }) => {
    return (
        <HorizontalLayout style={{ width:"unset",gap: "0.3rem" }}>
            <CopyMode
                owner={viewStatus}
                active={courseData?.published}
                setMode={handleCopyMode}
            />
            <EditMode
            setMode={handleEditMode}
            active={courseData?.published}
            owner={viewStatus} />

            <ToggleSwitchOption
                courseData={courseData}
                handleTogglePublish={handleTogglePublish} 
                owner={viewStatus}
            />

        </HorizontalLayout>
    )
}


const ToggleSwitchOption = ({ courseData, handleTogglePublish, owner }) => {
    return (
          owner && 
        <div style={{
            display: 'flex', justifyContent: "center", "alignItems": "center", backgroundColor: "white", width: "3.8rem", height: "3rem",
        }}>
          <ToggleSwitch className={"standard-margin"} checked={courseData?.published === 1} onChange={handleTogglePublish} />
        </div>
    )
}

const CopyMode = ({ active, owner, setMode }) => {
    return (
        owner &&
        <IconButton
            onClick={setMode}
            style={{ backgroundColor: "white", width: "3.8rem", height: "3.14rem", }}
            color={"primary-600"}
            size={25}
            icon2={"copy"}
        />
    )
}

const EditMode = ({ active, owner, setMode }) => {
    return (
        owner &&
        <IconButton
            onClick={setMode}
            style={{ backgroundColor: "white", width: "3.8rem", height: "3.14rem", }}
            color={"primary-600"}
            size={25}
            icon2={active ? "bijwerken" : "bijwerken-off"}
        />
    )
}